<template>
  <div>
    <div class="col-12">
      <div v-if="LoadingEvaluaciones"><i class="fas fa-spinner fa-spin fa-2x text-primary"></i></div>
      <div v-else class="align-items-center">
        <div>
          <vs-button class="w-100" v-if="!habilitado" @click.prevent="AbrirInformacionNuevaEvaluacion" style="height: 40px;">
            <i class="fas fa-circle-plus mr-1" style="font-size: 1.2rem"></i>
            Agregar nueva evaluación
          </vs-button>
        </div>

        <div v-if="ListaEvaluaciones.length === 0">No hay contenidos aun cargados</div>
        <div v-else>
          <div v-for='(evaluacion, indexEvaluacion) in ListaEvaluaciones' :key='indexEvaluacion'
               class="col-12 pr-0 mb-2">
            <div class="  d-flex align-items-center bg-dark rounded" >
              <b-dropdown class="position-absolute" style="top: 0; right: 0" size="sm" variant="link"
                          toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                  <i class="fas fa-ellipsis" style="font-size: 1.5rem"></i>
                </template>
                <b-dropdown-item-button @click="ObtenerPreguntas(evaluacion.ID)">
                  <i class="fas fa-gear"></i>
                  {{ habilitado ? 'Visualizar' : 'Administrar'}}
                </b-dropdown-item-button>
                <b-dropdown-item-button  @click="ObtenerEvaluacionId(evaluacion.ID)">
                  <i class="fas fa-edit"></i> {{ habilitado ? 'Modificar fecha' : 'Editar'}}
                </b-dropdown-item-button>
                <b-dropdown-item-button  @click="EliminarEvaluacion(evaluacion.ID)" v-if="!habilitado">
                  <i class="fas fa-trash text-danger"></i>
                  <span class="text-danger ml-1">Eliminar</span>
                </b-dropdown-item-button>
              </b-dropdown>
              <div class="row pl-2" style="width:100% !important;">
                <div class="col-3 d-flex justify-content-center align-items-center">
                  <div class="p-2 p-lg-3 rounded-circle d-flex justify-content-center align-items-center bg-success"
                       style="width: 60px; height: 60px; 'box-shadow: 0 -1px 33px -8px var(--green); -webkit-box-shadow: 0 -1px 33px -8px var(--green); -moz-box-shadow: 0 -1px 33px -8px var(--green);">
                    <i class="fa-solid fa-file-pen" style='font-size: 1.7rem;'></i>
                  </div>
                </div>
                <div class=" col-9 pl-0 ml-0 my-2 py-2  ">
                  <h4 class="font-weight-bold text-capitalize">{{ evaluacion.Titulo }}</h4>
                  <p class="font-weight-bold text-capitalize pb-0 mb-0" v-if="evaluacion.Habilitada">La evaluación está habilitada
                    ✅</p>
                  <p class="font-weight-bold text-capitalize pb-0 mb-0" v-else>La evaluación está deshabilitada ❌</p>
                  <p class="text-white-100 m-0 custom-descripcion">{{ evaluacion.Descripcion }}</p>
                  <div class="d-flex pt-1">
                    <p class="text-white-50  m-0 custom-descripcion">
                      <strong>N° preguntas: {{ evaluacion.CantidadPreguntas }} | Preguntas Registradas:
                        {{ evaluacion.CantidadPreguntasRegistradas }} </strong>
                    </p>
                    <span class="px-1">|</span>
                    <b class="text-danger  m-0 custom-descripcion">
                      <i class="fas fa-clock mr-1"></i>
                      <span class="text-danger">Tiempo máximo: </span>
                      <b> <code style='font-size: .8rem;margin-left: 2px;'>{{ evaluacion.TiempoEvaluacionMinutos }} min</code></b>                      
                    </b>
                  </div>
                  <div class="d-flex align-items-center text-white-50 flex-wrap mt-2">
                  <span class="text-primary  ">{{ evaluacion.FechaApertura | formatLastUpdateDate }}
                    a {{ evaluacion.FechaCierre | formatLastUpdateDate }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Actualizar Información basica evaluación -->
    <b-modal v-model="VisibilidadActualizacionEvaluacion" id="EvaluacionAjuste" title="Administrar evaluación" size="xl"
             hide-footer centered>
      <b-form class="container-fluid" @submit.prevent="ActualizarInformacionEvaluacion">
        <b-form-group label="Título" label-for="titulo">
          <b-form-input id="titulo" v-model="evaluacionActualizacion.Titulo" :disabled="habilitado" required>
          </b-form-input>
        </b-form-group>
        <b-form-group label="Descripción" label-for="descripcion">
          <b-form-textarea id="descripcion" v-model="evaluacionActualizacion.Descripcion" :disabled="habilitado" rows="3">
          </b-form-textarea>
        </b-form-group>
        <div class="row">
          <b-form-group class="col-4" label="Tiempo de evaluación (minutos)" label-for="tiempo">
            <b-form-input id="tiempo" type="number" v-model="evaluacionActualizacion.TiempoEvaluacionMinutos"
                          required :disabled="habilitado"></b-form-input>
          </b-form-group>

          <b-form-group class="col-4" label="Cantidad de preguntas" label-for="cantidad">
            <b-form-input id="cantidad" type="number" v-model="evaluacionActualizacion.CantidadPreguntas"
                          required :disabled="habilitado"></b-form-input>
          </b-form-group>

          <b-form-group class="col-4" label="Cantidad de Intentos permitidos" label-for="cantidad">
            <b-form-input :min="1" id="Intentos" type="number" v-model="evaluacionActualizacion.CantidadIntentos"
                          @input="validarCantidadIntentosActualizacion" :disabled="habilitado" required></b-form-input>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group class="col-6" label="Fecha de inicio" label-for="fecha-inicio">
            <b-form-input id="fecha-inicio" type="datetime-local" :min="fechaActual"
                          v-model="evaluacionActualizacion.FechaInicioGeneral"></b-form-input>
          </b-form-group>
          <b-form-group class="col-6" label="Fecha de finalización" label-for="fecha-fin">
            <b-form-input :disabled="evaluacionActualizacion.FechaInicioGeneral === null" id="fecha-fin"
                          type="datetime-local" v-model="evaluacionActualizacion.FechaFinGeneral"
                          :required="evaluacionActualizacion.FechaInicioGeneral != null"
                          :min="evaluacionActualizacion.FechaInicioGeneral"></b-form-input>
          </b-form-group>
        </div>
        <vs-button :loading="LoadingActualizacionEvaluacion" variant="primary">Guardar
        </vs-button>
      </b-form>
    </b-modal>

    <!-- Nueva Información basica evaluación -->
    <b-modal v-model="VisibilidadCreacionEvaluacion" id="EvaluacionNuevaModal" title="Nueva evaluación" size="xl"
             hide-footer centered>
      <b-form class="container-fluid" @submit.prevent="CrearInformacionEvaluacion">
        <b-form-group label="Título" label-for="titulo">
          <b-form-input id="titulo" v-model="EvaluacionNueva.Titulo" required></b-form-input>
        </b-form-group>
        <b-form-group label="Descripción" label-for="descripcion">
          <b-form-textarea id="descripcion" v-model="EvaluacionNueva.Descripcion" rows="3"></b-form-textarea>
        </b-form-group>
        <div class="row">
          <b-form-group class="col-4" label="Tiempo de evaluación (minutos)" label-for="tiempo">
            <b-form-input id="tiempo" type="number" v-model="EvaluacionNueva.TiempoEvaluacionMinutos"
                          required></b-form-input>
          </b-form-group>

          <b-form-group class="col-4" label="Cantidad de preguntas" label-for="cantidad">
            <b-form-input id="cantidad" type="number" v-model="EvaluacionNueva.CantidadPreguntas"
                          required></b-form-input>
          </b-form-group>
          <b-form-group class="col-4" label="Cantidad de Intentos permitidos" label-for="cantidad">
            <b-form-input :min="1" id="Intentos" type="number" v-model="EvaluacionNueva.CantidadIntentos"
                          @input="validarCantidadIntentos" required></b-form-input>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group class="col-6" label="Fecha de inicio" label-for="fecha-inicio">
            <b-form-input id="fecha-inicio" type="datetime-local"
                          v-model="EvaluacionNueva.FechaInicioGeneral" :min="fechaActual"></b-form-input>
          </b-form-group>

          <b-form-group class="col-6" label="Fecha de finalización" label-for="fecha-fin">
            <b-form-input :disabled="EvaluacionNueva.FechaInicioGeneral === null" id="fecha-fin" type="datetime-local"
                          v-model="EvaluacionNueva.FechaFinGeneral" :min="EvaluacionNueva.FechaInicioGeneral"
                          :required="EvaluacionNueva.FechaInicioGeneral != null">
            </b-form-input>
          </b-form-group>
        </div>
        <vs-button variant="primary" :loading="LoadingCreacionEvaluacion" type="submit">
          Guardar
        </vs-button>
      </b-form>
    </b-modal>

    <!-- Creacion Actualizacion preguntas de evaluacion -->
    <b-modal v-model="VisibilidadPreguntasEvaluacion" id="VisibilidadPreguntasEvaluacion"
             title="Administración Evaluación"
             size="xl" hide-footer centered>
      <card>
        <div v-for="(pregunta, index) in ListaPreguntas" :key="pregunta.ID" class="pregunta-card">

          <!-- Número de Pregunta -->
          <div class="d-flex justify-content-between">
            <h5 class="pregunta-titulo">Pregunta {{ index + 1 }}</h5>
            <vs-button class="bg-danger" @click="eliminarPregunta(index)" v-if="!habilitado">
              <i class="fas fa-trash"></i>
            </vs-button>
          </div>
          <hr>
          <div class="container-fluid">
            <div class="row">
              <b-form-group class="col-12" label="Enunciado">
                <b-form-textarea v-model="pregunta.Enunciado" rows="4" max-rows="8" :disabled="habilitado"
                                 placeholder="Escribe la pregunta aquí...">
                </b-form-textarea>
              </b-form-group>
            </div>
            <div class="row">
              <b-form-group class="col-4" label="Tipo de pregunta">
                <b-form-select v-model="pregunta.TipoRespuesta" :options="TipoRespuestas" :text-field="'Tipo'" :disabled="habilitado"
                               :value-field="'Codigo'" class="mt-2"></b-form-select>
              </b-form-group>

              <b-form-group v-if="pregunta.TipoRespuesta === 2" class="col-4" label="La pregunta es verdadera?">
                <b-form-checkbox class="mt-2" size="xl" v-model="pregunta.EsVerdadero" :disabled="habilitado"></b-form-checkbox>
              </b-form-group>
            </div>
            <!-- Respuestas Dinámicas -->
            <div v-if="pregunta.TipoRespuesta !== 2 && pregunta.TipoRespuesta !==3" class="mt-3">
              <h6>Opciones de Respuesta</h6>
              <vs-table style="overflow: visible !important;">
                <template #thead>
                  <vs-tr>
                    <vs-th style="min-width: 270px !important; background: var(--body-bg) !important">
                      Respuesta
                    </vs-th>
                    <vs-th style="min-width: 150px !important; background: var(--body-bg) !important">
                      Correcta
                    </vs-th>
                    <vs-th style="min-width: 100px !important; background: var(--body-bg) !important">
                      Acciones
                    </vs-th>
                  </vs-tr>
                </template>

                <template #tbody>
                  <vs-tr v-for="(respuesta, rIndex) in pregunta.RespuestasEvaluacionesAcademias" :key="respuesta.ID">
                    <vs-td>
                      <b-form-input v-model="respuesta.TextoRespuesta" :disabled="habilitado" placeholder="Escribe una opción de respuesta..."
                                    class="input-respuesta"></b-form-input>
                    </vs-td>
                    <vs-td>
                      <b-form-checkbox v-model="respuesta.EsCorrecta" :disabled="habilitado"
                                       @change="seleccionarUnicaCorrecta(index, rIndex)"></b-form-checkbox>
                    </vs-td>
                    <vs-td class="d-flex justify-content-center">
                      <vs-button class="bg-danger" @click="eliminarRespuesta(index, rIndex)" v-if="!habilitado">
                        <i class="fas fa-trash"></i>
                      </vs-button>
                    </vs-td>
                  </vs-tr>
                </template>

                <template #footer>
                  <div class="d-flex justify-content-center">
                    <vs-button class="d-flex" style="gap: 1rem;" primary @click="agregarRespuesta(index)" v-if="!habilitado">
                      <ion-icon style="font-size: 1.6rem" name="add-outline"></ion-icon>
                      Agregar Respuesta
                    </vs-button>
                  </div>
                </template>
              </vs-table>

            </div>
          </div>
        </div>

        <!-- Botón para Agregar Nueva Pregunta -->
        <div class="text-center mt-4 d-flex">
          <vs-button v-if="!habilitado" class="btn-agregar-pregunta" @click="agregarPregunta">
            <ion-icon style="font-size: 1.6rem" name="add-outline"></ion-icon>
            Agregar Pregunta
          </vs-button>
          <vs-button v-if="!habilitado" :loading="LoadingAdministrarEvaluacion" class="d-flex" style="gap: 1rem;" success
                     @click="AdministrarPreguntasEvaluacion()">
            Guardar Información
          </vs-button>
        </div>
      </card>
    </b-modal>

  </div>
</template>
<script>
import moment_timezone from "moment-timezone";
import Swal from "sweetalert2";

export default {
  name: "Evaluacion_component",
  props: {
    idClase: {
      type: String,
      required: true,
    },
    habilitado: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      ListaEvaluaciones: [],
      evaluacionActualizacion: {},
      EvaluacionNueva: {
        CursoClaseAcademiaID: null,
        Titulo: null,
        Descripcion: null,
        TiempoEvaluacionMinutos: null,
        CantidadPreguntas: null,
        FechaInicioGeneral: null,
        FechaFinGeneral: null,
        CantidadIntentos: null
      },
      fechaActual: this.$moment().tz("America/Bogota").format("YYYY-MM-DDTHH:mm"),
      LoadingEvaluaciones: false,
      LoadingCreacionEvaluacion: false,
      LoadingActualizacionEvaluacion: false,
      LoadingAdministrarEvaluacion: false,
      VisibilidadCreacionEvaluacion: false,
      VisibilidadActualizacionEvaluacion: false,
      VisibilidadPreguntasEvaluacion: false,
      evaluacionActualizacionId: null,
      EvaluacionPreguntasId: null,
      ListaPreguntas: [],
      TipoRespuestas: [
        {"Codigo": 0, "Tipo": "Seleccion Multiple"},
        {"Codigo": 1, "Tipo": "Multiple Respuesta Correcta"},
        {"Codigo": 2, "Tipo": "Verdadero Falso"},
        {"Codigo": 3, "Tipo": "TextoLibre"},
      ]
    };
  },
  mounted() {
    this.ObtenerEvaluacionesClase();
  },
  methods: {
    async ObtenerEvaluacionesClase() {
      this.LoadingEvaluaciones = true;
      this.ListaEvaluaciones = [];
      await this.$store.dispatch('hl_get', {
        path: 'EvaluacionesAcademia/ObtenerEvaluacionesClaseAcademia/' + this.idClase
      }).then(res => {
        if (res.respuesta) {
          this.ListaEvaluaciones = res.data;
        }
      }).finally(this.LoadingEvaluaciones = false)
    },
    async ObtenerEvaluacionId(EvaluacionId) {
      await this.$store.dispatch('hl_get', {
        path: 'EvaluacionesAcademia/ObtenerEvaluacionInformacion/' + EvaluacionId
      }).then(res => {
        if (res.respuesta) {
          this.evaluacionActualizacion = res.data;
          this.evaluacionActualizacionId = EvaluacionId;
          this.VisibilidadActualizacionEvaluacion = true;
        }
      })
    },
    async ActualizarInformacionEvaluacion() {
      this.LoadingActualizacionEvaluacion = true;
      await this.$store.dispatch('hl_post', {
        path: 'EvaluacionesAcademia/ActualizarEvaluacion/' + this.evaluacionActualizacionId,
        data: this.evaluacionActualizacion
      }).then(res => {
        if (res.respuesta) {
          Swal.fire("Listo!", res.mensaje, "success");
        } else {
          Swal.fire("Error!", res.mensaje, "error");
        }
      }).finally(() => {
        this.ObtenerEvaluacionesClase();
        this.LoadingActualizacionEvaluacion = false;
        this.VisibilidadActualizacionEvaluacion = false;
      })
    },
    async AbrirInformacionNuevaEvaluacion() {
      this.EvaluacionNueva = {
        CursoClaseAcademiaID: this.idClase,
        Titulo: null,
        Descripcion: null,
        TiempoEvaluacionMinutos: null,
        CantidadPreguntas: null,
        FechaInicioGeneral: null,
        FechaFinGeneral: null
      }
      this.VisibilidadCreacionEvaluacion = true;
    },
    async CrearInformacionEvaluacion() {
      this.LoadingCreacionEvaluacion = true
      await this.$store.dispatch('hl_post', {
        path: "EvaluacionesAcademia/CrearEvaluacion", data: this.EvaluacionNueva
      }).then(res => {
        if (res.respuesta) {
          Swal.fire("Listo!", res.mensaje, "success");
        } else {
          Swal.fire("Error!", res.mensaje, "error");
        }
      }).finally(() => {
        this.ObtenerEvaluacionesClase();
        this.LoadingCreacionEvaluacion = false;
        this.VisibilidadCreacionEvaluacion = false;
      })
    },
    async ObtenerPreguntas(evaluacionId) {
      this.ListaPreguntas = [];
      this.EvaluacionPreguntasId = evaluacionId;
      await this.$store.dispatch('hl_get', {
        path: 'EvaluacionesAcademia/ObtenerPreguntasEvaluacion/' + evaluacionId
      }).then(res => {
        if (res.respuesta) {
          this.ListaPreguntas = res.data;
        }
      }).finally(
          this.VisibilidadPreguntasEvaluacion = true
      )
    },
    async AdministrarPreguntasEvaluacion() {
      this.LoadingAdministrarEvaluacion = true;
      await this.$store.dispatch('hl_post', {
        path: 'EvaluacionesAcademia/CrearModificarPreguntas/' + this.EvaluacionPreguntasId,
        data: this.ListaPreguntas
      }).then(res => {
        if (res.respuesta) {
          Swal.fire("Listo!", res.mensaje, "success");
          this.ObtenerEvaluacionesClase();
          this.VisibilidadPreguntasEvaluacion = false
        } else {
          Swal.fire("Error!", res.mensaje, "error");
        }
      }).finally(this.LoadingAdministrarEvaluacion = false)
    },
    async EliminarEvaluacion(evaluacionID) {
      this.$store.dispatch('hl_delete', {
        path: "EvaluacionesAcademia/ELiminarEvaluacion/" + evaluacionID
      }).then(res => {
        if (res.respuesta) {
          Swal.fire("Listo!", res.mensaje, "success");
        } else {
          Swal.fire("Error!", res.mensaje, "error");
        }
      }).finally(() => {
        this.ObtenerEvaluacionesClase();
      })
    },

    agregarPregunta() {
      this.ListaPreguntas.push({
        Enunciado: "",
        TipoRespuesta: 0,
        EsVerdadero: false,
        RespuestasEvaluacionesAcademias: []
      });
    },
    eliminarPregunta(index) {
      this.ListaPreguntas.splice(index, 1);
    },
    agregarRespuesta(index) {
      this.ListaPreguntas[index].RespuestasEvaluacionesAcademias.push({
        TextoRespuesta: '',
        EsCorrecta: false
      });
    },
    eliminarRespuesta(pIndex, rIndex) {
      this.ListaPreguntas[pIndex].RespuestasEvaluacionesAcademias.splice(rIndex, 1);
    },
    validarCantidadIntentos() {
      if (this.EvaluacionNueva.CantidadIntentosPermitidos < 1) {
        this.EvaluacionNueva.CantidadIntentosPermitidos = 1;
      }
    },
    validarCantidadIntentosActualizacion() {
      if (this.EvaluacionNueva.CantidadIntentosPermitidos < 1) {
        this.EvaluacionNueva.CantidadIntentosPermitidos = 1;
      }
    },
    seleccionarUnicaCorrecta(index, rIndex) {
      var pregunta = this.ListaPreguntas[index];

      if (pregunta.TipoRespuesta === 0) {
        pregunta.RespuestasEvaluacionesAcademias.forEach((respuesta, i) => {
          if (i !== rIndex) {
            respuesta.EsCorrecta = false;
          }
        });
      }
    }
  },
  filters: {
    formatLastUpdateDate(fechaOriginal) {
      return moment_timezone
          .tz(fechaOriginal, "America/Bogota")
          .format("MMM D, YYYY");
    },
  },
};
</script>

<style>
.pregunta-card {
  padding: 1rem;
  border-radius: 10px;
  margin-bottom: 1rem;
}

.vs-table {
  overflow: visible !important;
}

.pregunta-titulo {
  font-weight: bold;
}

.respuesta-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.input-respuesta {
  flex-grow: 1;
}

.btn-agregar-respuesta {
  background: #28a745;
  color: white;
  border-radius: 5px;
}

.btn-agregar-pregunta {
  background: #007bff;
  color: white;
  border-radius: 5px;
}

</style>